<ng-container *ngIf="true">
    <div class="container flex flex-middle"
         [ngClass]="component.background_color || ''"
         *ngIf="component">
        <div *ngFor="let i of [].constructor(10); let isFirst = first"
             class="scrolling flex flex-middle"
             [style.animationDuration]="component.animation_duration + 's' || '5s' "
             [attr.aria-hidden]="!isFirst">
            <span class="flex flex-middle"
                  *ngFor="let item of component.text_list"
                  [ngClass]="component.text_color || ''">
                <span class="p1 p-r-5"
                      *iCms="'text' of item; content: 'html'"></span>
                <img class="m-r-5"
                     [image]="component.divider"
                     [options]="{fitIn: true}"
                     [style.width.rem]="0.75"
                     [style.height.rem]="0.75"
                     *ngIf="component.divider">
            </span>
        </div>
    </div>
</ng-container>